import type { ReactNode } from 'react';

import type { KeyValuePair } from '../../../types/caller.js';

const VALID_COLOR = '#0078d4';
const INVALID_COLOR = '#c50f1f';

export function renderVarHighlight(
  text: string,
  vars: KeyValuePair[],
): ReactNode {
  const parts = text.split(/(\{\{[^}]*\}\})/);
  return parts.map((part, i) => {
    const match = /^\{\{([^}]*)\}\}$/.exec(part);
    if (match) {
      const name = (match[1] ?? '').trim();
      const valid = vars.some((v) => v.enabled && v.key === name);
      return (
        <mark
          key={i}
          style={{
            backgroundColor: 'transparent',
            color: valid ? VALID_COLOR : INVALID_COLOR,
          }}
        >
          {part}
        </mark>
      );
    }
    return <span key={i}>{part}</span>;
  });
}
